export default __webpack_public_path__ + "static/media/StorePickup.aa6e0ef3.png";